import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send, Copy } from "lucide-react";
import { opApi, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

// Email a prospect the sample-website link for one widget (sent by Morr Notify).
export function ShareWidgetDialog({ w, slug, open, onOpenChange }) {
  const [f, setF] = useState({ to: "", name: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [fallback, setFallback] = useState("");
  const url = `${window.location.origin}/w/${slug}/${w.key}?site=1`;
  const set = (k) => (e) => { setFallback(""); setF((x) => ({ ...x, [k]: e.target.value })); };
  const send = async () => {
    setBusy(true); setFallback("");
    try {
      await opApi.post("/admin/widgets/share", { ...f, widget_key: w.key, widget_label: w.label, product: w.product, url });
      toast.success(`Sent to ${f.to}`);
      onOpenChange(false);
    } catch (e) {
      const msg = apiError(e.response?.data?.detail);
      if (e.response?.status === 424) setFallback(msg); else toast.error(msg);
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none" data-testid={`widget-share-dialog-${w.key}`}>
        <DialogHeader>
          <DialogTitle>Send {w.label} to a client</DialogTitle>
          <DialogDescription>They get an email with a link to see it on a sample website.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Input className="rounded-none" type="email" placeholder="Client email" value={f.to} onChange={set("to")} data-testid="widget-share-to" />
          <Input className="rounded-none" placeholder="Client name (optional)" value={f.name} onChange={set("name")} data-testid="widget-share-name" />
          <Textarea className="rounded-none" rows={3} placeholder="Short note (optional)" value={f.message} onChange={set("message")} data-testid="widget-share-message" />
          <div className="text-xs text-muted-foreground break-all">Link: {url}</div>
          {fallback && (
            <div className="border border-amber-300 bg-amber-50 p-2 text-xs flex items-start gap-2" data-testid="widget-share-fallback">
              <span className="flex-1">{fallback}</span>
              <button type="button" onClick={() => navigator.clipboard.writeText(url).then(() => toast.success("Link copied"))} data-testid="widget-share-copy-link"><Copy className="h-4 w-4" /></button>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-none" onClick={() => onOpenChange(false)} data-testid="widget-share-cancel">Cancel</Button>
          <Button className="rounded-none gap-1.5" disabled={busy || !f.to.includes("@")} onClick={send} data-testid="widget-share-send">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
